module.exports = __webpack_public_path__ + "static/media/Arrow-Thin-Left.ad5e10c3.svg";